import JurisdictionSelect from './JurisdictionSelect';

export default JurisdictionSelect;
